import React, { useEffect, useState } from 'react';
import CuadroDivisionArgentina from './CuadroDivisionArgentina.js';
import MensajeCargando from '../UI/MensajeCargando.js';
import MensajeError from '../UI/MensajeError.js';
import useGetListaURL from '../../hooks/useGetListaURL.js';
import styles from './RecuadroArgentina.module.css';

const ID_ARGENTINA = 1;
const NIVEL_MAX_EXCLUIDO = 90;

/**
 * Recuadro con las divisiones vigentes de Argentina (nivelActual < 90),
 * ordenadas por nivelActual e id. Cada división muestra los participantes
 * del torneo más reciente.
 */
const RecuadroArgentina = () => {
  const [divisiones, setDivisiones] = useState([]);
  const [expandido, setExpandido] = useState(true);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    fetchData('paises/' + ID_ARGENTINA + '/divisiones?vigente=true', (lista) => {
      const filtradas = (lista || [])
        .filter((d) => d.nivelActual == null || d.nivelActual < NIVEL_MAX_EXCLUIDO)
        .sort((a, b) => {
          const nivelA = a.nivelActual ?? 999;
          const nivelB = b.nivelActual ?? 999;
          if (nivelA !== nivelB) return nivelA - nivelB;
          return a.id - b.id;
        });
      setDivisiones(filtradas);
    });
  }, [fetchData]);

  return (
    <div className={styles.recuadro}>
      <div className={styles.encabezado}>
        <span className={styles.titulo}>Argentina</span>
        <button
          className={styles.botonCerrar}
          onClick={() => setExpandido((v) => !v)}
          title={expandido ? 'Cerrar' : 'Abrir'}
          aria-expanded={expandido}
        >
          {expandido ? '▲' : '▼'}
        </button>
      </div>
      <div className={expandido ? undefined : styles.contenidoOculto}>
        <MensajeCargando isCargando={isCargando} />
        <MensajeError errores={erroresGetLista} />
        {!isCargando && (
          <div className={styles.grillaDivisiones}>
            {divisiones.map((division) => (
              <CuadroDivisionArgentina key={division.id} division={division} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default RecuadroArgentina;
